import { Anchor, Badge, Card, Flex, Grid, Text, Tooltip } from '@mantine/core';
import { IconHistory } from '@tabler/icons-react';
import { useLocation } from 'react-router';
import CatalogTriggerStats from './CatalogTriggerStats';

const CatalogTriggersCards = ({ stats, catalogTriggers }) => {
  const location = useLocation();

  const catalogTriggerElements = [];
  for (let i = 0; i < catalogTriggers.length; i++) {
    const catalogTrigger = catalogTriggers[i];

    catalogTriggerElements.push(
      <Card key={catalogTrigger.id} mb="md" data-catalog-trigger-name={catalogTrigger.name} withBorder>
        <Card.Section inheritPadding py="sm">
          <Grid>
            <Grid.Col span={{ base: 12, sm: 5 }}>
              <Anchor href={`#${location.pathname}/${catalogTrigger.id}`} fw={600}>
                {catalogTrigger.name}
              </Anchor>
              <Flex gap="xs">
                <Tooltip
                  label={
                    <>
                      <div>Created: {new Date(catalogTrigger.createdAt).toLocaleString()}</div>
                      <div>Updated: {new Date(catalogTrigger.updatedAt).toLocaleString()}</div>
                    </>
                  }
                  position="top"
                  withArrow
                >
                  <Badge variant="default" style={{ cursor: 'pointer' }}>
                    <IconHistory size={14} style={{ verticalAlign: 'middle' }} />
                  </Badge>
                </Tooltip>
              </Flex>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 3 }}>
              <CatalogTriggerStats stats={stats} catalogTrigger={catalogTrigger} />
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 4 }} style={{ textAlign: 'right' }}>
              <Text size="sm" c="dimmed" fw={600}>
                Rules:
              </Text>
              {catalogTrigger.catalogRules && catalogTrigger.catalogRules.length > 0 && (
                <Text size="sm" c="dimmed">
                  {catalogTrigger.catalogRules.map((rule) => rule.name).join(', ')}
                </Text>
              )}
              {catalogTrigger.audienceRules && catalogTrigger.audienceRules.length > 0 && (
                <Text size="sm" c="dimmed">
                  {catalogTrigger.audienceRules
                    .map((rule) => (rule.inverseSelection ? `Not ${rule.name}` : rule.name))
                    .join(', ')}
                </Text>
              )}
            </Grid.Col>
          </Grid>
        </Card.Section>
      </Card>
    );
  }

  return catalogTriggerElements;
};

export default CatalogTriggersCards;
